/**
 * Онбординг «код-входа» — persistence (work-020, решение 5).
 *
 * На InboxScreen показываем Banner «Пришли из сторис?» если пользователь
 * открыл приложение без ask-токена. Закрытие баннера запоминается в
 * localStorage — повторно не показываем.
 *
 * localStorage может быть недоступен (private mode, отключённое хранилище):
 * читаем как «не скрыт», запись молча проглатываем — деградируем к
 * «баннер покажется снова», а не к падению (CANON G3).
 */
export const CODE_ONBOARDING_KEY = 'veylme:code_onboarding_dismissed';

/** true, если пользователь уже закрыл онбординг (баннер показывать не нужно). */
export function isCodeOnboardingDismissed(): boolean {
  try {
    return localStorage.getItem(CODE_ONBOARDING_KEY) === '1';
  } catch {
    return false;
  }
}

/** Сохранить факт закрытия онбординга. Молча no-op, если localStorage недоступен. */
export function dismissCodeOnboarding(): void {
  try {
    localStorage.setItem(CODE_ONBOARDING_KEY, '1');
  } catch {
    // localStorage недоступен — закрытие не запомнится, баннер покажется
    // снова при следующем открытии. Допустимый деградированный путь (CANON G3).
  }
}
